import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { App } from "./containers/App";
import { __getStore__ } from "./redux/store";
import { Voxco } from "./public";
import "./i18n";

console.log(
    "%c%s",
    "font-size: 10px; color: #1b9aff",
    `
                                .((((((((((((((
                                ((((((((((((()
                                ((((((((((((+   /
                                (((((((((((+   ((
                     ...        ((((+++(((/   (((        ...           ....
)(()       .(()   +(((++(((+    ((((+   (/   ((((    .(((((((()<   .((()++(((+
 -(((     /((+  /((/     .(((   ((((()     .(((((   ((((     )<.  /((/      (((.
   (((.  /((/   (()        (((   \\+++++....+++++.  )(((           (()        (((
    )(((((((    (((        (((        /((((        )(((           (((       .(((
     \\((((-     -(().    /((+        (((-(((.       \\(().   .+()- -(().    <((+
      )(+-        )+((((((+.        (((-  (((.        )+(((((+<.    )+((((()+.
                                   (((-
                                 .(()
                                )((+
https://www.voxco.com/
`,
);
console.log(`🚀 SurveyEngineJS v${Voxco.version} © Voxco ${new Date().getFullYear()}`);

// This is the entry point for development environments.
// We can add development-specific dependencies here.

require("../lib/mobiscroll/css/mobiscroll.javascript.min.css");

(window as any).Voxco = Voxco;

require("./assets/main.less");

ReactDOM.render(
    <Provider store={__getStore__()}>
        <App />
    </Provider>,
    document.getElementById("root"),
);

function onDisconnectedModeInit() {
    if (this.readyState === this.DONE) {
        const survey = JSON.parse(this.responseText);
        Voxco.init({
            debug: true,
            mode: "preview",
            messages: true,
            mobileMode: false,
            survey,
            containerHost: "http://localhost:4444",
            displayInThemeEditor: false,
            hideAccessibilityPanel: true,
        });
    }
}

function onIntegratedServerInit() {
    if (this.readyState === this.DONE) {
        const psid = this.getResponseHeader("X-VX-PSID");

        if (psid) {
            const psidInputElement = document.createElement("input");
            psidInputElement.type = "hidden";
            psidInputElement.id = "S2_SessionId";
            psidInputElement.value = psid;

            document.body.appendChild(psidInputElement);
        }

        Voxco.init({
            debug: true,
            mode: "preview",
            messages: true,
            mobileMode: false,
            apiUrl: "/s2",
            containerHost: "http://localhost:4444",
            displayInThemeEditor: false,
            hideAccessibilityPanel: false,
        });
    }
}

if (process.env.NODE_ENV === "development") {
    const DEBUG_TOKEN = "kN5wYQ3jD8zLhE7fZJ1rXq6mP4sTcB9oVx0aRnG2uWl8vIpOgFyMAbEtUkSj";

    const inputElement = document.createElement("input");
    inputElement.type = "hidden";
    inputElement.name = "__RequestVerificationToken";
    inputElement.value = DEBUG_TOKEN;

    document.body.appendChild(inputElement);

    if (process.env.FULL_INTEGRATED_MODE === "true") {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.addEventListener("readystatechange", onIntegratedServerInit);
        xhr.open(
            "GET",
            `/s2/sl?debug=1&cid=${process.env.CLIENT_ID}&sid=${
                process.env.SURVEY_ID
            }&nocookie=1&m=1&tui=${new Date().getTime()}`,
        );
        xhr.send();
    } else {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.addEventListener("readystatechange", onDisconnectedModeInit);
        xhr.open("GET", `/api/offline/survey/export/json/${process.env.SURVEY_ID}`);
        xhr.setRequestHeader(
            "Authorization",
            `Client ${decodeURIComponent(process.env.API_TOKEN)}`,
        );
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send();
    }
}
